<mat-card *ngIf="timeSheet" class="overview-card total-table-border">
	<mat-card-header class="overview-card-header" fxLayout="row wrap">
		<h3 class="text-center font-weight-bold my-xs">
			<span class="readonly-label">Current Time Sheet</span>
			({{ timeSheet?.startDate | date: 'MMMM, yyyy' }})
		</h3>
	</mat-card-header>
	<mat-card-content class="card-content no-padding pa-1">
		<mat-list>
			<mat-list-item>
				<div fxFlex="33.33%" class="text-center">
					<h5 mat-line class="font-weight-bold ma-0">{{ totalTrips?.displayValue }}</h5>
					<p mat-line class="readonly-label no-margin-tb">Trips</p>
				</div>
				<div fxFlex="33.33%" class="text-center">
					<h5 mat-line class="font-weight-bold ma-0">
						{{ timeSheet.totals.totalOfHoursSummary.total | hoursMinutes }}
					</h5>
					<p mat-line class="readonly-label no-margin-tb">Flight Hours</p>
				</div>
				<div fxFlex="33.33%" class="text-center">
					<h5 mat-line class="font-weight-bold ma-0">
						{{ timeSheet.totals.totalOfHoursSummary.overGuaranteedHours | hoursMinutes }}
					</h5>
					<p mat-line class="readonly-label no-margin-tb">Hours Over Guaranteed</p>
				</div>
			</mat-list-item>
			<mat-list-item class="mt-3">
				<div fxFlex="33.33%" class="text-center">
					<h5 mat-line class="font-weight-bold ma-0">
						{{ timeSheet.totals.totalOfPayVariablesTotals.total | currency }}
					</h5>
					<p mat-line class="readonly-label no-margin-tb">Total Pay</p>
				</div>
				<div fxFlex="33.33%" class="text-center">
					<h5
						[ngClass]="dueDate >= 0 && dueDate <= timeSheet.timeSheetLockOutDay ? 'due-date' : ''"
						mat-line
						class="font-weight-bold ma-0"
					>
						<span *ngIf="dueDate > 0">{{ dueDate }} days</span>
						<span *ngIf="dueDate === 0">Today</span>
					</h5>
					<p mat-line class="readonly-label no-margin-tb">Due <span *ngIf="dueDate > 0">in</span></p>
				</div>
			</mat-list-item>
		</mat-list>
	</mat-card-content>

	<mat-card-actions class="card-action-box">
		<button color="primary" mat-button>
			<span class="text-xl" (click)="navigate(timeSheet.employeeId)">Edit</span>
		</button>
	</mat-card-actions>
</mat-card>
